module.exports = __webpack_public_path__ + "static/media/watch_nav_bands.51d87bf7.svg";